import { createStore, createHook, type Action } from 'react-sweet-state';

export type State = {
	selectedWeekStart: Date | null;
};

export const initialState: State = {
	selectedWeekStart: null,
};

export const actions = {
	setSelectedWeekStart:
		(newWeekStartDate: Date): Action<State> =>
		({ getState, setState }) => {
			const { selectedWeekStart: previousWeekStart } = getState();

			if (
				previousWeekStart === null ||
				previousWeekStart.getTime() !== newWeekStartDate.getTime()
			) {
				setState({
					selectedWeekStart: newWeekStartDate,
				});
			}
		},
} as const;

type Actions = typeof actions;

const Store = createStore<State, Actions>({
	name: 'depFreqSelectedWeekStore',
	initialState,
	actions,
});

export const useSelectedWeekStore = createHook(Store);

// NOTE: we cannot use this hook because two different Dates pass an equality check :(
// possibly a bug in sweet-state. We should either store milliseconds, or just keep
// it as is and not use a selector.
// export const useSelectedWeekStart = createHook<State, Actions, Date | null, void>(Store, {
//     selector: (state) => state.selectedWeekStart,
// });
